export default class TreeNodeRenderer {
    constructor(tree) {
        this.tree = tree;
    }

    //  abstract
    generateContent(treeNode, targetEl) {
    }

    getNodeClasses(treeNode) {
        const classes = ["node", this.getSpecificNodeClassName()];

        if (this.tree.getExpandController().isCollapsed(treeNode))
            classes.push("collapsed");

        if (this.tree.hasActiveFilter()) {
            if (this.tree.doesMatchFilterCriteria(treeNode))
                classes.push("matchesFilterCriteria");
            if (this.tree.doesContainChildrenMatchingFilterCriteria(treeNode))
                classes.push("containsChildrenMatchingFilterCriteria");
        }

        const parentTreeNode = treeNode.getParent();
        if (parentTreeNode && parentTreeNode.getChildren().length > 1)
            classes.push("hasSiblings");

        return classes;
    }

    //  abstract
    getSpecificNodeClassName() {

    }

    updateUI(treeNode) {
        const uiObject = this.tree.getUIObjectForNode(treeNode)
        if (uiObject.nodeEl) {
            uiObject.nodeEl.className = this.getNodeClasses(treeNode).join(" ");
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/TreeNodeRenderer.js